var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UnitTestDataOverride_1;
// this lives in pipes domain so that if can be used both here in MetadataMap and computations domain
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './unitTestColumnOverride'; // force import for JsonSchemaV2
import { unitTestDataOverrideSchemaValidation } from '../validations.generated';
export var OverrideType;
(function (OverrideType) {
    OverrideType["originalEmpty"] = "originalEmpty";
    OverrideType["unitTestData"] = "unitTestData";
})(OverrideType || (OverrideType = {}));
export const unitTestDataOverrideSchema = {
    $id: 'urn:wisepipe-common-pipe:UnitTestDataOverride',
    type: 'object',
    properties: {
        overrideType: { type: 'string', enum: Object.values(OverrideType) },
        unitTestDataSourceID: { type: 'string' },
        columnOverrides: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:UnitTestColumnOverride' },
            uniqueItemProperties: ['originalColName']
        }
    },
    required: ['overrideType'],
    if: { properties: { overrideType: { const: OverrideType.unitTestData } } },
    then: { required: ['unitTestDataSourceID'] }
};
let UnitTestDataOverride = UnitTestDataOverride_1 = class UnitTestDataOverride {
    constructor(overrideType, unitTestDataSourceID, columnOverrides) {
        this.overrideType = overrideType;
        if (unitTestDataSourceID !== undefined)
            this.unitTestDataSourceID = unitTestDataSourceID;
        if (columnOverrides !== undefined)
            this.columnOverrides = columnOverrides;
        JSON.validate(this, UnitTestDataOverride_1);
    }
};
UnitTestDataOverride = UnitTestDataOverride_1 = __decorate([
    JsonSchemaV2(unitTestDataOverrideSchema, unitTestDataOverrideSchemaValidation)
], UnitTestDataOverride);
export { UnitTestDataOverride };
//# sourceMappingURL=unitTestDataOverride.js.map